import { Alert, Button, Flex, Input, Space } from "antd";
import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import "./SponsorSearch.css";
import { getStudy } from "@/utils/studyFetch";

const STUDY_MESSAGES = {
    invalidNctInput: "Invalid input. NCT IDs are 'NCT' followed by 8 digits.",
    serverError: "An error occurred while fetching the study. Please try again later.",
    missingStudy: "We do not have that study in our records. Please check the NCT ID or try another.",
};

const Sponsor = () => {
    const [userInput, setUserInput] = useState<string>();
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const handleError = (errorMessage: string) => {
        setError(errorMessage);
        setTimeout(() => setError(null), 6000);
    };
    const handleGetLink = useCallback(
        (event: React.SubmitEvent) => {
            event.preventDefault();
            if (userInput === undefined) {
                handleError(STUDY_MESSAGES.invalidNctInput);
                return;
            }

            const lowerCaseInput = userInput.toLowerCase();
            const nctIdMatch = lowerCaseInput.match(/nct\d{8}/gi);

            if (nctIdMatch) {
                const studyId = nctIdMatch[0].toUpperCase();

                getStudy(studyId)
                    .then((study) => {
                        if (study && study.data) {
                            navigate(`/study/${studyId}`);
                        } else {
                            handleError(STUDY_MESSAGES.missingStudy);
                        }
                    })
                    .catch(() => {
                        handleError(STUDY_MESSAGES.serverError);
                    });
            } else {
                handleError(STUDY_MESSAGES.invalidNctInput);
            }
        },
        [navigate, userInput]
    );

    return (
        <form onSubmit={handleGetLink}>
            <Space className="mt-2 mb-2">
                <Input
                    type="text"
                    size="large"
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    placeholder="Ex: NCT12345678"
                />
                <Button size="large" htmlType="submit" type="primary">
                    Get Link
                </Button>
            </Space>
            {error && <Alert title={error} type="error" />}
        </form>
    );
};

const SponsorSearchForStudy = () => (
    <div>
        <h1 className="inverse-header mt-5">Already Have a Study in Mind?</h1>
        <Flex vertical align="center" className="mt-2 mb-4 share-study-container">
            <p className="text-gray " style={{ fontSize: "1.35rem" }}>
                Do you have a National Clinical Trial (NCT) ID or URL from ClinicalTrials.gov?
                <br />
                <span className="primary-text medium-text">
                    Enter the NCTID or Link below to find our simplified version
                </span>
            </p>
            <Sponsor />
        </Flex>
    </div>
);
export default SponsorSearchForStudy;
